import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

export function getMuiFormHelperText(_theme: Theme): MuiThemeComponentOverride<"MuiFormHelperText"> {
  return {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: "unset",
          marginRight: "unset",
        },
      },
    },
  };
}
